import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';

export default function RequireAuth({ children }: { children: ReactElement }) {
  const { accounts } = useMsal();
  const location     = useLocation();
  if (!accounts.length) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }}   
      />
    );
  }
  return children;
}
